import { signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { isAdminRole, isUsherRole, normalizeRole } from '../constants/membership';

export const fetchUserRole = async (uid) => {
  const snap = await getDoc(doc(db, 'users', uid));
  return normalizeRole(snap.exists() ? snap.data()?.role : '');
};

export const resolveAdminPanelAccess = (role) => {
  if (isAdminRole(role)) return 'admin';
  if (isUsherRole(role)) return 'usher';
  return 'denied';
};

export const signOutAdminFirebase = async () => {
  if (!auth.currentUser) {
    return;
  }

  await signOut(auth);
};
